export enum ThreePLPackingGroupType {
  NoPacking = 'NoPacking',
  Boxes = 'Boxes',
  Containers = 'Containers',
  Barrels = 'Barrels'
}
